import clsx from "clsx";

import { useScrollReveal } from "./useScrollReveal";

export function NarrativeCallout({
  headline,
  subtext,
}: {
  headline: React.ReactNode;
  subtext?: React.ReactNode;
}) {
  const { ref, isVisible } = useScrollReveal(0.3);

  return (
    <div ref={ref} className="py-8 text-center">
      <h2
        className={clsx(
          "text-3xl leading-tight font-bold transition-all duration-1000 md:text-4xl",
          isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0",
        )}
      >
        {headline}
      </h2>
      {subtext && (
        <p
          className={clsx(
            "text-textSubtle mx-auto mt-4 max-w-lg text-lg leading-relaxed transition-all duration-1000",
            isVisible
              ? "translate-y-0 opacity-100"
              : "translate-y-10 opacity-0",
          )}
          style={{ transitionDelay: isVisible ? "200ms" : "0ms" }}
        >
          {subtext}
        </p>
      )}
    </div>
  );
}
